import React, { useState } from "react";
import { experienceData } from "../../data/mock";
import { Badge } from "../ui/badge";
import {
  ChevronRight,
  Building2,
  Calendar,
  GitCommitVertical,
  Play,
} from "lucide-react";

const ExperienceSection = () => {
  const [activeExp, setActiveExp] = useState(0);
  const exp = experienceData[activeExp];

  return (
    <section id="experience" className="relative">
      <div className="section-container">
        <span className="section-label">Experience</span>
        <h2 className="section-title">Professional Journey</h2>
        <div className="gradient-line mb-12" />

        <div className="grid md:grid-cols-[280px_1fr] gap-8">
          {/* Timeline sidebar */}
          <div className="flex md:flex-col gap-3">
            {experienceData.map((item, i) => (
              <button
                key={item.id}
                onClick={() => setActiveExp(i)}
                className={`text-left p-4 rounded-xl transition-all duration-300 border relative overflow-hidden ${
                  activeExp === i
                    ? "bg-[#0A1628] border-[#06B6D4]/25 shadow-lg shadow-[#06B6D4]/5"
                    : "bg-transparent border-[#1E293B]/50 hover:bg-[#0A1628]/50 hover:border-[#1E3A5F]/50"
                }`}
              >
                {activeExp === i && (
                  <div className="absolute left-0 top-0 bottom-0 w-[2px] bg-[#06B6D4]" />
                )}
                <div className="flex items-center gap-2 mb-1">
                  <Building2
                    size={13}
                    className={activeExp === i ? "text-[#06B6D4]" : "text-[#475569]"}
                  />
                  <span
                    className={`text-[11px] font-['Fira_Code'] ${
                      activeExp === i ? "text-[#06B6D4]" : "text-[#475569]"
                    }`}
                  >
                    {item.company}
                  </span>
                </div>
                <h4
                  className={`text-sm font-semibold font-['Figtree'] ${
                    activeExp === i ? "text-[#F1F5F9]" : "text-[#94A3B8]"
                  }`}
                >
                  {item.role}
                </h4>
                <div className="flex items-center gap-1.5 mt-1">
                  <Calendar size={11} className="text-[#475569]" />
                  <span className="text-[10px] text-[#475569] font-['Fira_Code']">
                    {item.period}
                  </span>
                </div>
              </button>
            ))}
          </div>

          {/* Detail panel - Terminal Style */}
          <div className="terminal-card">
            <div className="terminal-header">
              <div className="terminal-dot bg-[#EF4444]" />
              <div className="terminal-dot bg-[#F59E0B]" />
              <div className="terminal-dot bg-[#22C55E]" />
              <span className="ml-3 text-[10px] text-[#475569] font-['Fira_Code']">
                experience/{exp.company.toLowerCase()}/{exp.role.toLowerCase().replace(/\s/g, "-")}.log
              </span>
            </div>

            <div className="p-6 md:p-8">
              {/* Header */}
              <div className="flex flex-wrap items-center gap-3 mb-1">
                <h3 className="text-lg font-bold font-['Figtree'] text-[#F1F5F9]">
                  {exp.role}
                </h3>
                <Badge
                  variant="outline"
                  className="border-[#06B6D4]/25 text-[#06B6D4] text-[10px] font-['Fira_Code']"
                >
                  {exp.team}
                </Badge>
              </div>
              <div className="flex items-center gap-2 text-xs text-[#64748B] mb-6 font-['Fira_Code']">
                <Building2 size={13} />
                <span>{exp.company}</span>
                <span className="text-[#1E293B]">|</span>
                <Calendar size={13} />
                <span>{exp.period}</span>
              </div>

              {/* Log entries */}
              <div className="space-y-3 mb-6">
                {exp.description.map((item, i) => (
                  <div key={i} className="flex items-start gap-3 group">
                    <div className="mt-1.5 shrink-0">
                      <GitCommitVertical
                        size={14}
                        className="text-[#06B6D4]/60 group-hover:text-[#06B6D4] transition-colors"
                      />
                    </div>
                    <span className="text-sm text-[#94A3B8] leading-relaxed">
                      {item}
                    </span>
                  </div>
                ))}
              </div>

              {/* Tech tags */}
              <div className="flex items-center gap-2 flex-wrap">
                <Play size={10} className="text-[#334155]" />
                {exp.technologies.map((tech) => (
                  <span
                    key={tech}
                    className="px-2.5 py-1 rounded text-[10px] bg-[#06B6D4]/5 text-[#06B6D4]/70 font-['Fira_Code'] border border-[#06B6D4]/10 hover:bg-[#06B6D4]/10 hover:text-[#06B6D4] transition-colors duration-200"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
